import React from 'react';
import { Container, Box, Button, Divider } from '@mui/material';
const Footer = () => {
	return (
		<div>
			<Box className='ft'>
				<Container>
					<Box
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
						}}>
						<Box>
							<p>Planning your next trip?</p>
							<p>
								Subscribe to our newsletter. Get the latest travel trends &
								deals!
							</p>
						</Box>
						<Box>
							<Button style={{ background: '#EC5B24', color: 'white' }}>
								Subscribe
							</Button>
						</Box>
					</Box>
				</Container>
			</Box>
			<Box className='ft2'>
				<Container>
					<span>About MusafirBazar</span>
					<p style={{ fontSize: 12 }}>
						Launched in 2007, ixigo is a technology company focused on
						empowering Indian travellers to plan, book and manage their trips
						across rail, air, buses and hotels. We assist travellers in making
						smarter travel decisions by leveraging artificial intelligence,
						machine learning, and data science led innovations on our OTA
						platforms, comprising our websites and mobile applications. Our
						vision is to become the most customer-centric travel company, by
						offering the best customer experience to our users. Our focus on
						travel utility and customer experience for travellers in the 'next
						billion user' segment is driven by technology, cost-efficiency and
						our culture of innovation has made us India's leading travel
						ecosystem for the 'next billion users'.
					</p>
				</Container>
				<Divider style={{ background: 'white' }} />
			</Box>
		</div>
	);
};

export default Footer;
